import { BaseRepository } from './base.repository';

/**
 * Repository para operações relacionadas a documentos (PDFs)
 */
export class DocumentosRepository extends BaseRepository {
  /**
   * Gera URL para download de Guia de Exame
   * @param codigoAgendamento - Código do agendamento (base64)
   * @returns URL completa para download do PDF
   */
  getGuiaUrl(codigoAgendamento: string): string {
    return `${this.baseURL}/documentos/guia/${codigoAgendamento}`;
  }

  /**
   * Gera URL para download de ASO
   * @param codigoAgendamento - Código do agendamento (base64)
   * @returns URL completa para download do PDF
   */
  getASOUrl(codigoAgendamento: string): string {
    return `${this.baseURL}/documentos/aso/${codigoAgendamento}`;
  }

  /**
   * Gera URL para download de Ficha Médica
   * @param codigoAgendamento - Código do agendamento (base64)
   * @returns URL completa para download do PDF
   */
  getFichaMedicaUrl(codigoAgendamento: string): string {
    return `${this.baseURL}/documentos/ficha-medica/${codigoAgendamento}`;
  }
}

